import axios from 'axios';
import change from 'redux-form';
import { browserHistory } from 'react-router';

import {
  REQUEST_VENDORS,
  FETCH_VENDORS_SUCCESS,
  FETCH_VENDORS_FAILURE,
  SELECT_VENDOR,
  RESET_CURRENT_VENDOR,
  REQUEST_CREATING_VENDOR,
  CREATE_VENDOR_SUCCESS,
  CREATE_VENDOR_FAILURE,
  REQUEST_EDITING_VENDOR,
  EDIT_VENDOR_SUCCESS,
  EDIT_VENDOR_FAILURE,
  REQUEST_VENDOR_DETAIL,
  FETCH_VENDOR_DETAIL_SUCCESS,
  FETCH_VENDOR_DETAIL_FAILURE,
  REQUEST_VENDOR_INVENTORY_DETAIL,
  FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS,
  FETCH_VENDOR_INVENTORY_DETAIL_FAILURE,
  REQUEST_VENDOR_RECORDS,
  FETCH_VENDOR_RECORDS_SUCCESS,
  FETCH_VENDOR_RECORDS_FAILURE,
  FETCH_VENDOR_BATCHES,
  FETCH_VENDOR_BATCHES_SUCCESS,
  FETCH_VENDOR_BATCHES_FAILURE,
  ATTACH_DOCUMENT,
  ATTACH_DOCUMENT_SUCCESS,
  ATTACH_DOCUMENT_FAILURE,
  FETCH_VENDOR_PRICE_TABLE,
  FETCH_VENDOR_PRICE_TABLE_SUCCESS,
  FETCH_VENDOR_PRICE_TABLE_FAILURE,
  FETCH_VENDOR_PRODUCTS,
  FETCH_VENDOR_PRODUCTS_SUCCESS,
  FETCH_VENDOR_PRODUCTS_FAILURE,
  UPDATE_VENDOR_PRICE_ITEM,
  CREATE_VENDOR_PRICE_ITEM,
  DELETE_VENDOR_PRICE_ITEM,
  FETCH_VENDOR_PRICE_TABLE_DETAIL,
  FETCH_VENDOR_PRICE_TABLE_DETAIL_SUCCESS,
  FETCH_VENDOR_PRICE_TABLE_DETAIL_FAILURE,
  UPDATE_VENDOR_PRICE_TABLE, UPDATE_VENDOR_PRICE_TABLE_FAILURE, UPDATE_VENDOR_PRICE_TABLE_SUCCESS,
} from './type';

import {
  VENDOR_URL,
  VENDOR_INVENTORY_URL,
  OUTSTANDING_VENDOR_URL,
  UPLOAD_URL, VENDOR_PRODUCTS_URL, VENDOR_PRICE_TABLE_URL,
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI, isVAK, isTQ, isGFD, isAP } from './root_url';

export function fetchVendors(filterParams = null) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    if (!selectedCompany) return;
    dispatch(requestVendors());
    let params = {}
    if (!(isGGI && filterParams && Object.keys(filterParams).length === 1)) {
      params.Company_id = selectedCompany.value
    }
    if (filterParams != null) {
      params = {
        ...filterParams,
        ...params,
      }
    }
    let vendorUrl = VENDOR_URL
    return axios.get(vendorUrl,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        params,
      })
      .then(response => {
        dispatch(fetchVendorsSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchVendorsFailure(err));
        }
      });
  }
}

export function fetchActiveVendors() {
  return (dispatch, getState) => {
    dispatch(requestVendors());
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    let url = `${VENDOR_URL}?Vendor_id__IsActive=1`;
    if((isVAK || isTQ || isGGI) && selectedCompany && selectedCompany.value) url = url + `&Company_id=${selectedCompany.value}`
    return axios({
      method: 'get',
      url,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }).then(response => {
      dispatch(fetchVendorsSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchVendorsFailure(err));
      }
    });
  }
}

export function requestVendors() {
  return {
    type: REQUEST_VENDORS,
  };
}

export function fetchVendorsSuccess(vendors) {
  return {
    type: FETCH_VENDORS_SUCCESS,
    payload: vendors
  };
}

export function fetchVendorsFailure(error) {
  return {
    type: FETCH_VENDORS_FAILURE,
    payload: error
  };
}

export function selectVendor(vendor) {
  return {
    type: SELECT_VENDOR,
    payload: vendor
  };
}

export function resetCurrentVendor() {
  return {
    type: RESET_CURRENT_VENDOR
  }
}


// Actions to deal with the promise of posting function.

export function createVendor({
  VendorNum,
  Note,
  BusinessType,
  AccountNo,
  CreditLimit,
  DefaultDebitAcct,
  DefaultCreditAcc,
  RefNum,
  Name,
  Description,
  CreditStatus,
  IsActive,
  overseas,
  Purchaser_User_id,
  PaymentTerm_id,
  Shipping,
  Mailing,
  Billing,
  country,
  website,
  note2,
  Country,
  Website,
  Note2,
  companyids = [],
  AssociatedCompany,
  Level,
}, {
Files,
currentGroups = [],
}) {
  if(PaymentTerm_id) {
    PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
  }
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    let data = {
      VendorNum,
      Note,
      BusinessType,
      AccountNo,
      CreditLimit,
      DefaultDebitAcct,
      DefaultCreditAcc,
      RefNum,
      Name,
      Description,
      CreditStatus,
      IsActive,
      overseas,
      Purchaser_User_id,
      PaymentTerm_id,
      Shipping,
      Mailing,
      Billing,
      Company_id: selectedCompany.value,
      AssociatedCompany: AssociatedCompany ? AssociatedCompany.value : null,
      country,
      website,
      note2,
      Country,
      Website,
      Note2,
      Files
    }
    if(isGGI) {
      data.companyids = companyids;
    }
    if(isAP) {
      if(currentGroups.length) {
        data.Groups = currentGroups;
      }
      data.Level = Level;
    }
    dispatch({ type: REQUEST_CREATING_VENDOR });
    axios.post(VENDOR_URL,
      data,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(createVendorSuccess());
      browserHistory.push('/vendors');
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(createVendorFailure(err));
      }
    });
  }
}

export function requestCreatingVendor() {
  return {
    type: REQUEST_CREATING_VENDOR
  }
}

export function createVendorSuccess() {
  return {
    type: CREATE_VENDOR_SUCCESS
  }
}

export function createVendorFailure(error) {
  return {
    type: CREATE_VENDOR_FAILURE,
    payload: error
  }
}

export function editVendor({
  Vendor_id,
  VendorNum,
  Note,
  BusinessType,
  AccountNo,
  CreditLimit,
  DefaultDebitAcct,
  DefaultCreditAcc,
  RefNum,
  Name,
  Description,
  CreditStatus,
  IsActive,
  overseas,
  Purchaser_User_id,
  PaymentTerm_id,
  Shipping,
  Mailing,
  Billing,
  country,
  website,
  note2,
  Country,
  Website,
  Note2,
  companyids = [],
  AssociatedCompany,
  Level,
}, {
Files,
currentGroups = [],  
}) {
  
  console.log('editVendor!!!'); 
  if (PaymentTerm_id) {
    PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
  }
  return (dispatch, getState) => {
    const state = getState();
    
    const selectedCompany = state.header.selectedCompany;
    let data = {
      VendorNum,
      Note,
      BusinessType,
      AccountNo,
      CreditLimit,
      DefaultDebitAcct,
      DefaultCreditAcc,
      RefNum,
      Name,
      Description,
      CreditStatus,
      IsActive,
      overseas,
      Purchaser_User_id,
      PaymentTerm_id,
      Shipping,
      Mailing,
      Billing,
      Company_id: selectedCompany.value,
      country,
      website,
      note2,
      Country,
      Website,
      Note2,
      Files,
    }

    if (isGFD) {
      data.AssociatedCompany = AssociatedCompany ? AssociatedCompany.value : null;
    }
    if(isGGI) {
      data.companyids = companyids;
    }
    if(isAP) {
      if(currentGroups.length) {
        data.Groups = currentGroups;
      }
      data.Level = Level;
    }
    
    dispatch({ type: REQUEST_EDITING_VENDOR });
    axios.put(
      (VENDOR_URL + Vendor_id), data,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(editVendorSuccess());
      browserHistory.push('/vendors'); // If editd succesfully, refresh the paymentTerm page.
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(editVendorFailure(err));
      }
    });
  }
}

export function requestEditingVendor() {
  return {
    type: REQUEST_EDITING_VENDOR
  }
}

export function editVendorSuccess() {
  return {
    type: EDIT_VENDOR_SUCCESS
  }
}

export function editVendorFailure(error) {
  return {
    type: EDIT_VENDOR_FAILURE,
    payload: error
  }
}

// Fetch the detail page.
export function fetchVendorDetail(vendor_id) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    dispatch(requestVendorDetail());
    let url = VENDOR_URL + vendor_id;
    if(isGGI) {
      url = url + `?Company_id=${selectedCompany.value}`
    }
    return axios.get(url,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(fetchVendorDetailSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchVendorDetailFailure(err));
      }
    });
  }
}

export function requestVendorDetail() {
  return {
    type: REQUEST_VENDOR_DETAIL,
  };
}

export function fetchVendorDetailSuccess(vendorDetail) {
  return {
    type: FETCH_VENDOR_DETAIL_SUCCESS,
    payload: vendorDetail
  };
}

export function fetchVendorDetailFailure(error) {
  return {
    type: FETCH_VENDOR_DETAIL_FAILURE,
    payload: error
  };
}

export function fetchVendorInventoryDetail(vendor_id) {
  return dispatch => {
    dispatch(requestVendorInventoryDetail());
    return axios.get(VENDOR_INVENTORY_URL + vendor_id,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(fetchVendorInventoryDetailSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchVendorInventoryDetailFailure(err));
      }
    });
  }
}

export function requestVendorInventoryDetail() {
  return {
    type: REQUEST_VENDOR_INVENTORY_DETAIL,
  };
}

export function fetchVendorInventoryDetailSuccess(vendorDetail) {
  return {
    type: FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS,
    payload: vendorDetail
  };
}

export function fetchVendorInventoryDetailFailure(error) {
  return {
    type: FETCH_VENDOR_INVENTORY_DETAIL_FAILURE,
    payload: error
  };
}

export function fetchVendorRecords() {
  return dispatch => {
    dispatch(requestVendorRecords());
    return axios.get(OUTSTANDING_VENDOR_URL,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(fetchVendorRecordsSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchVendorRecordsFailure(err));
      }
    });
  }
}

export function requestVendorRecords() {
  return {
    type: REQUEST_VENDOR_RECORDS
  }
}

export function fetchVendorRecordsSuccess(records) {
  return {
    type: FETCH_VENDOR_RECORDS_SUCCESS,
    payload: records
  }
}

export function fetchVendorRecordsFailure(error) {
  return {
    type: FETCH_VENDOR_RECORDS_FAILURE,
    payload: error
  }
}

export function getVendorBatches(vendor_id, isDefective = false) {
  const params = {};
  if (isDefective) {
    params.is_defective = true;
  }
  return dispatch => {
    dispatch({type: FETCH_VENDOR_BATCHES});
    return axios.get(VENDOR_INVENTORY_URL+vendor_id,
      {
        params,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(getVendorBatchesSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(getVendorBatchesFailure(err));
      }
    });
  }
}

function getVendorBatchesSuccess(data) {
  return {
    type: FETCH_VENDOR_BATCHES_SUCCESS,
    payload: data
  }
}

function getVendorBatchesFailure(error) {
  return {
    type: FETCH_VENDOR_BATCHES_FAILURE,
    payload: error
  }
}

export function attachDocument(files) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    dispatch({type: ATTACH_DOCUMENT});
    var data = new FormData();
    data.append('vendor_file', files[0]);
    //UPLOAD_URL + 'vendor/' <--- old api
    return axios.post(
      `${VENDOR_URL}import/${selectedCompany.value}`,
      data,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then(response => {
        dispatch(attachDocumentSuccess(response));
        alert('Import Success');
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(attachDocumentFailure(err));
        }
      });
  }
}

export function attachDocumentSuccess() {
  return {
    type: ATTACH_DOCUMENT_SUCCESS,
  };
}

export function attachDocumentFailure(error) {
  return {
    type: ATTACH_DOCUMENT_FAILURE,
    payload: error
  };
}

export function fetchVendorPriceTable(vendorId) {
  return dispatch => {
    dispatch({type: FETCH_VENDOR_PRICE_TABLE});
    axios.get(`${VENDOR_PRICE_TABLE_URL}`, {
      params: {vendor_id: vendorId},
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }).then(response => {
      dispatch({type: FETCH_VENDOR_PRICE_TABLE_SUCCESS, data: response.data});
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
        dispatch({type: FETCH_VENDOR_PRICE_TABLE_FAILURE});
      }
    });
  }
}

export function fetchVendorProducts(vendorId) {
  return dispatch => {
    dispatch({type: FETCH_VENDOR_PRODUCTS});
    axios.get(`${VENDOR_PRODUCTS_URL}`, {
      params: {vendor: vendorId, limit: 9999},
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }).then(response => {
        dispatch({type: FETCH_VENDOR_PRODUCTS_SUCCESS, data: response.data.record});
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
        dispatch({type: FETCH_VENDOR_PRODUCTS_FAILURE});
      }
    });
  }
}

export function updateVendorPriceItem(index, item) {
  return {
    type: UPDATE_VENDOR_PRICE_ITEM,
    index,
    item,
  }
}
export function createVendorPriceItem(item) {
  return {
    type: CREATE_VENDOR_PRICE_ITEM,
    item,
  }
}

export function deleteVendorPriceItem(index) {
  return {
    type: DELETE_VENDOR_PRICE_ITEM,
    index,
  }
}

export function fetchVendorPriceTableDetail(id) {
  return dispatch => {
    dispatch({
      type: FETCH_VENDOR_PRICE_TABLE_DETAIL,
    });
    axios.get(`${VENDOR_PRICE_TABLE_URL}${id}/`, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }).then(response => {
      dispatch({
        type: FETCH_VENDOR_PRICE_TABLE_DETAIL_SUCCESS,
        data: {
          Product_id: {value: response.data.Product_id},
          Quote_date: moment(response.data.Quote_date),
          MOQ: response.data.MOQ,
          Lead_time: response.data.Lead_time,
          Quote_Validity: response.data.Quote_Validity,
          Notation: response.data.Notation,
          priceList: response.data.quantity_price_list.map(item => ({
            minQty: item.min_quantity,
            maxQty: item.max_quantity,
            price: item.quantity_price
          })),
        }
      })
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
        dispatch({type: FETCH_VENDOR_PRICE_TABLE_DETAIL_FAILURE});
      }
    })
  }
}

export function vendorPriceTableSubmit(vendorId, { Product_id, Quote_date, MOQ, Lead_time, Quote_Validity, Notation }, callback = () => {}) {
  return (dispatch, getState) => {
    const priceList = getState().vendors.priceTable.currentVendorPrice.priceList;
    dispatch({
      type: UPDATE_VENDOR_PRICE_TABLE,
    });
    axios.post(`${VENDOR_PRICE_TABLE_URL}`, {
      Product_id: Product_id.value || Product_id,
      Vendor_id: vendorId,
      Quote_date,
      MOQ,
      Lead_time,
      Quote_Validity,
      Notation,
      quantity_price_list: priceList.map(item => ({
        max_quantity: +item.maxQty,
        min_quantity: +item.minQty,
        quantity_price: +item.price,
      }))
    }, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }).then(response => {
      callback();
      dispatch({
        type: UPDATE_VENDOR_PRICE_TABLE_SUCCESS,
      });
    }, err => {
      alert(err.data)
      dispatch({
        type: UPDATE_VENDOR_PRICE_TABLE_FAILURE,
        err,
      })
    });
  }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/vendors_actions.js